import Repository from "@/repositories/Repository";
import store from "@/store";

const resource = "/qr_code"

export default {
    getQrCodeByUid(uid: string) {
        return Repository.get(`${process.env.VUE_APP_FOURDATA_API_BASE_URL}/api/v1${resource}/${uid}/detail`, {
            headers: {
                Authorization: `Basic ${store.getters["authentication/user_uid"]}`,
            },
        });
    },
}